import styled from 'styled-components/macro';

export const StyledSidebar = styled.aside`
    display: flex;
    flex-direction: column;
    grid-area: sidebar;
    overflow: hidden;
`;
